import * as React from "react";
const SvgFiRrCursorPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cursor-plus_svg__a)">
      <path
        fill="#062147"
        d="M16 8a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 14a6 6 0 1 1 0-12 6 6 0 0 1 0 12m4-6a1 1 0 0 1-1 1h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 2 0v2h2a1 1 0 0 1 1 1M12 4.98a1 1 0 0 0-.586-.89L2.739.146a1 1 0 0 0-.09-.037A1.99 1.99 0 0 0 .047 1.598c-.078.382-.044.778.099 1.14l3.944 8.676a1 1 0 0 0 .89.586H5a1 1 0 0 0 .895-.553l1.85-3.7 3.7-1.85a1 1 0 0 0 .554-.916M6.552 6.106a1 1 0 0 0-.448.448L5.04 8.68 2 2.005l6.679 3.038z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cursor-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCursorPlus;
